import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import Questions from "../Questions/Questions.js";
import useSEO from "../../../hooks/useSEO.js";
import seoConfig from "../../../hooks/seoConfig.js";

export default function ProfessionalRetraining() {
  useSEO(seoConfig.professionalRetraining);
  return (
    <section className="contacts additional">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Профессиональная переподготовка по специальности "Косметология"
      </h1>

      <h3 className="about-nii__title antiCorruption__title additional__title">
        ГБУ «УрНИИДВиИ» проводит профессиональную переподготовку по
        специальности "Косметология".
      </h3>

      <p className="dissertation__text">
        Продолжительность обучения 576 учебных часов.
      </p>
      <p className="dissertation__text">
        Занятия и лекции проводят ведущие специалисты института: профессора,
        доктора и кандидаты медицинских наук.
      </p>
      <p className="dissertation__text">
        По окончании циклов слушателям, успешно сдавшим экзамены, выдаются
        документы государственного образца, утвержденные Государственным
        комитетом Российской Федерации по высшему образованию (сертификат
        специалиста, диплом о профессиональной переподготовки).
      </p>

      <p className="dissertation__text">
        Для врачей дерматовенерологов при зачислении на цикл обучения необходимо
        иметь документы, заверенные нотариусом:
      </p>
      <ul>
        <li>
          <p className="dissertation__text">Паспорт;</p>
        </li>
        <li>
          <p className="dissertation__text">
            Диплом об окончании высшего медицинского образовательного учреждения
            по специальности "лечебное дело" или "педиатрия";
          </p>
        </li>
        <li>
          <p className="dissertation__text">
            Удостоверение об окончании ординатуры, интернатуры, либо диплом о
            профессиональной переподготовке по специальности
            "дерматовенерология";
          </p>
        </li>
        <li>
          <p className="dissertation__text">
            Сертификат специалиста по дерматовенерологии;
          </p>
        </li>
        <li>
          <p className="dissertation__text">Копию трудовой книжки.</p>
        </li>
      </ul>

      <Questions />
    </section>
  );
}
